module.exports = __webpack_public_path__ + "assets/img/62@3x.b0e59f49.png";